import LogBgActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  dataIn:{},
  dataRejectIn:{},
  dataRejectOut:{},
  isNewRecord:false,
  showModalIn:false,
  showModalOut:false,
  showModaRejectlOut:false,
  showModalRejectIn:false,
  showModalOut:false,
  onSubmit:false,
  single:null,
  helperLogBg:null,
  helperFullLogBg:null,
  errorInternal:false,
  reject:false
};

function LogBgReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LogBgActions.RESET_LIST:
      return INITIAL_STATE;
    case LogBgActions.NEW_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case LogBgActions.UPDATE_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, single:null,isNewRecord:false};
    case LogBgActions.VIEW_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case LogBgActions.VIEW_DATA_IN:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, dataIn:action.payload,isNewRecord:false,showModalIn:true,reject:false};
    case LogBgActions.VIEW_DATA_OUT:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, dataOut:action.payload,isNewRecord:false,showModalOut:true,reject:false};
    case LogBgActions.RESET_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModalIn:false,showModalOut:false,};
    case LogBgActions.DELETE_DATA:
      return { ...state, errorInternal:false, onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case LogBgActions.ON_SUBMIT:
      return { ...state,errorInternal:false, onSubmit:true};
    case LogBgActions.SHOW_DATA:
      return { ...state, errorInternal:false, onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case LogBgActions.SUCCESS_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isError: false, showModalOut:false,showModalIn:false,form:INITIAL_STATE.form , onSubmit:false};
    case LogBgActions.ERROR_DATA:
      return { ...state, onSubmit:false, errorInternal:false,  isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case LogBgActions.PROCESS_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: true, isError: false,isSuccess:false};
    case LogBgActions.GET_HELPER_LOG_BG:
      return { ...state, errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperLogBg:action.payload};
    case LogBgActions.GET_HELPERFULL_LOG_BG:
      return { ...state, errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperFullLogBg:action.payload};
    case LogBgActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case LogBgActions.REJECT_DATA_IN:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, dataIn:action.payload,isNewRecord:false,reject:true,showModalIn:true};
    case LogBgActions.REJECT_DATA_OUT:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, dataOut:action.payload,isNewRecord:false,reject:true,showModalOut:true};    
    default:
      return state;
    }
}

export default LogBgReducer;
